"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateVehicleResponseSchema = exports.UpdateVehicleRequestSchema = void 0;
var _axios = require("axios");
var _zod = require("zod");
const UpdateVehicleRequestSchema = exports.UpdateVehicleRequestSchema = _zod.z.object({
  nickName: _zod.z.string().optional(),
  preferredVehicle: _zod.z.enum(["Y", "N"]).optional(),
  vehicleId: _zod.z.string()
});

/**
 * Currently unused as of 03/24/2025
 */
const UpdateVehicleResponseSchema = exports.UpdateVehicleResponseSchema = _zod.z.object({
  statusCode: _zod.z.literal(_axios.HttpStatusCode.Ok),
  body: _zod.z.object({
    data: _zod.z.object({
      make: _zod.z.enum(["L", "T"]),
      model: _zod.z.string().optional(),
      modelYear: _zod.z.string().optional(),
      /**
       * If nickname did not exist prior and empty string is passed as nick name then no nickname is returned.
       * If nickname existed prior and and empty string is passed as nick name then returned nickname is empty string.
       */
      nickName: _zod.z.string().optional().transform(function (x) {
        return !x ? undefined : x;
      }),
      preferredVehicle: _zod.z.enum(["Y", "N"]),
      vehicleId: _zod.z.string(),
      vin: _zod.z.string().optional()
    })
  })
});